import React from 'react';
import Select from 'react-select';

const NewDropdown = ({ register, name, onChange, requiredMessage, dataList, placeholder, dropDownContentType, value, allowMultiple,disabled }) => {

    let newDataList = dataList;
    if(dataList && dataList.length>0) {
        newDataList = dataList.map(item => ({
            value: item._id || item.value,
            label: item.label || item.name || item.organiserType || item.title || item.description || 'N/A'
        }));
    }

    // Find the selected value object(s)
    let selectedValue = null;
    if (allowMultiple) {
        // For multiselect, value should be an array of IDs
        selectedValue = value && Array.isArray(value) 
            ? newDataList?.filter(item => value.includes(item.value)) 
            : [];
        // Debug logging for multiselect
        if (name === 'productIdsArray') {
            console.log('NewDropdown - allowMultiple:', allowMultiple);
            console.log('NewDropdown - value:', value);
            console.log('NewDropdown - newDataList:', newDataList);
            console.log('NewDropdown - selectedValue:', selectedValue);
        }
    } else {
        // For single select, find the matching option
        selectedValue = value ? newDataList?.find(item => item.value === value) : null;
    }
    
    const handleChange = (selectedOption) => {
        if (allowMultiple) {
            // For multiselect, return an array of values
            const values = selectedOption ? selectedOption.map(option => option.value) : [];
            onChange({ value: values });
        } else {
            // For single select, return the selected value
            onChange({ value: selectedOption ? selectedOption.value : null });
        }
    };

    return (
        <Select
            placeholder={placeholder || "Select an option"}
            options={newDataList}
            value={selectedValue}
            onChange={handleChange}
            isDisabled={disabled}
            isMulti={allowMultiple || false}
            isClearable={true}
            menuPortalTarget={document.body}
            className={`flex-1 shrink self-stretch basis-0 bg-transparent border-none  outline-none text-base ${disabled ? 'cursor-not-allowed bg-navBtn' : 'cursor-pointer'} `}
            styles={{
                control: (base) => ({
                    ...base,
                    backgroundColor: 'transparent',
                    border: '1px solid rgba(236, 236, 238, 1)',
                    borderRadius: '0.375rem',
                    boxShadow: 'none',
                    padding: '0.2rem',
                    ":hover": {
                        borderColor: '#16ad3c',
                    },
                }),
                menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                }),
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                }),
                option: (base, { isSelected }) => ({
                    ...base,
                    backgroundColor: isSelected ? '#16ad3c' : 'white', // Custom background for selected option
                    color: isSelected ? 'white' : 'black', // Custom text color for selected option
                    ":active": {
                        backgroundColor: isSelected ? '#16ad3c' : 'rgba(0, 0, 0, 0.1)', // Active state
                    },
                    ":hover": {
                        backgroundColor: isSelected ? '#16ad3c' : 'rgba(52, 199, 89, 0.3)', // Hover state
                    },
                }),
                singleValue: (base) => ({
                    ...base,
                    color: 'black',
                }),
                placeholder: (base) => ({
                    ...base,
                    color: 'gray',
                }),
                dropdownIndicator: (base) => ({
                    ...base,
                    color: 'gray',
                }),
                indicatorSeparator: (base) => ({
                    ...base,
                    display: 'none',
                }),
                clearIndicator: (base) => ({
                    ...base,
                    color: 'gray',
                }),
                valueContainer: (base) => ({
                    ...base,
                    padding: '0.25rem',
                }),
                input: (base) => ({
                    ...base,
                    color: 'black',
                }),
                menuList: (base) => ({
                    ...base,
                    maxHeight: '200px',
                }),
            }}
        />
    )
}

export default NewDropdown